import {
  FETCH_COMBINED_VIEW_DATA_REQUEST,
  GET_COMBINED_VIEW_FILES_REQUEST,
  GET_COMBINED_VIEW_NOTES_REQUEST,
  GET_COMBINED_VIEW_LOGS_REQUEST,
  GET_COMBINED_VIEW_PROFILES_REQUEST,
  UPDATE_COMBINED_VIEW_DATA_REQUEST,
  SETTINGS_FILTER_REQUEST,
  USERS_FILTER_REQUEST,
  ACTIVITY_TITLE_FILTER_REQUEST,
  DATE_FILTER_REQUEST,
  RESET_ALL_COMBINED_VIEW_DATA,
  REMOVE_PDATA,
  RESET_COMBINED_VIEW_DATA,
  FETCH_COMBINED_VIEW_WORKKARD_FILES_REQUEST,
  DOWNLOAD_ALL_FILES,
  SET_DOWNLOAD_CLICKED_STATE,
  SET_IS_VIEW_CHANGE,
  RESET_ALL_DOWNLOAD_FILE_DATA,
  FETCH_PRINT_COMBINED_VIEW_DATA_REQUEST,
  RESET_PRINT_COMBINED_VIEW_DATA,
  UPDATE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA,
  SAVE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA,
} from "../../../containers/WorkkardDetail/actions/actionConstants";

export const fetchCombinedViewData =payload=>({
    type:FETCH_COMBINED_VIEW_DATA_REQUEST,
    payload
  })

export const getCombinedViewFiles =payload=>({
  type:GET_COMBINED_VIEW_FILES_REQUEST,
  payload
})


export const getCombinedViewNotes =payload=>({
  type:GET_COMBINED_VIEW_NOTES_REQUEST,
  payload
})

export const getCombinedViewLogs =payload=>({
  type:GET_COMBINED_VIEW_LOGS_REQUEST,
  payload
})


export const getCombinedViewProfiles =payload=>({
  type:GET_COMBINED_VIEW_PROFILES_REQUEST,
  payload
})

export const getSettingsFilteredData =  payload => ({
    type:SETTINGS_FILTER_REQUEST,
    payload
})

export const getUsersFilteredData =  payload => ({
  type:USERS_FILTER_REQUEST,
  payload
})

export const getActivityTitleFilteredData =  payload => ({
  type:ACTIVITY_TITLE_FILTER_REQUEST,
  payload
})

export const getDateFilteredData = payload => ({
  type: DATE_FILTER_REQUEST,
  payload
})

export const updateCombinedViewData=payload =>({
  type:UPDATE_COMBINED_VIEW_DATA_REQUEST,
  payload
})

export const resetCombinedView = payload => ({
  type:RESET_ALL_COMBINED_VIEW_DATA,
  payload
})

export const removePdataCombinedView = payload => ({
  type:REMOVE_PDATA,
  payload
})

export const resetCombinedViewData = payload => ({
  type:RESET_COMBINED_VIEW_DATA,
  payload
})

export const downloadAllFiles = payload => ({
  type: DOWNLOAD_ALL_FILES,
  payload
})

export const fetchCombinedViewWorkkardFiles = payload => ({
  type: FETCH_COMBINED_VIEW_WORKKARD_FILES_REQUEST,
  payload
})

export const updateDownloadClickedState = payload => ({
  type: SET_DOWNLOAD_CLICKED_STATE,
  payload
})

export const updateViewType = payload => ({
  type: SET_IS_VIEW_CHANGE,
  payload
})

export const resetDownloadFilesData = payload => ({
  type: RESET_ALL_DOWNLOAD_FILE_DATA,
  payload
})

export const fetchPrintCombinedViewData = payload => ({
  type:FETCH_PRINT_COMBINED_VIEW_DATA_REQUEST,
  payload
})

export const resetPrintPreviewData = payload =>({
  type:RESET_PRINT_COMBINED_VIEW_DATA,
  payload
})

export const updatedeselectednotetemplates = (payload) => ({
  type: UPDATE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA,
  payload,
});

export const savedeselectednotetemplates = (payload) => ({
  type: SAVE_DESELECTED_NOTE_TEMPLATE_COMBINED_VIEW_DATA,
  payload,
});